import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { PublicClientApplication, EventType, AuthenticationResult } from '@azure/msal-browser';
import { msalConfigCorporate } from './config';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * This manager app uses corporate Azure AD authentication only (no B2C).
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalCorporateInstance = new PublicClientApplication(msalConfigCorporate);

// Setup event callbacks for Corporate instance
msalCorporateInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        if (payload.account) {
            msalCorporateInstance.setActiveAccount(payload.account);
        }
    }
});

// Initialize MSAL instance, then handle redirect
msalCorporateInstance.initialize().then(async () => {
    console.log('[MSAL Init] Path:', window.location.pathname);
    
    // Handle any pending auth redirects
    const response = await msalCorporateInstance.handleRedirectPromise();
    if (response) {
        console.log('[MSAL Init] Corporate login successful');
    }

    const container = document.getElementById('root');
    if (!container) {
        throw new Error('Root element not found');
    }
    const root = createRoot(container);
    
    root.render(
        <React.StrictMode>
            <App msalInstance={msalCorporateInstance} />
        </React.StrictMode>
    );
}).catch((error) => {
    console.error('[MSAL Init] Error:', error);
});
